import { MegaraxUri } from "./uri";

export const getMegaraxUriFromPath = (pathname: string, search = ""): MegaraxUri | undefined => {
  const path = pathname === "/" ? "home" : pathname.replace(/^\//, "");
  const query = search && !search.startsWith("?") ? `?${search}` : search;

  const withQuery = MegaraxUri.serializer.deserialize(`megarax://${path}${query}`);
  if (withQuery.isOk) return withQuery.value;

  const withoutQuery = MegaraxUri.serializer.deserialize(`megarax://${path}`);
  return withoutQuery.isOk ? withoutQuery.value : undefined;
};
